var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 426.667 426.667",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288 192c17.707 0 32-14.293 32-32s-14.293-32-32-32-32 14.293-32 32 14.293 32 32 32z",
    "data-original": "#000000",
    className: "smile_svg__active-path",
    "data-old_color": "#000000",
    fill: "#5200F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213.227 0C95.36 0 0 95.467 0 213.333s95.36 213.333 213.227 213.333 213.44-95.467 213.44-213.333S331.093 0 213.227 0zm.106 384c-94.293 0-170.667-76.373-170.667-170.667S119.04 42.667 213.333 42.667 384 119.04 384 213.333 307.627 384 213.333 384z",
    "data-original": "#000000",
    className: "smile_svg__active-path",
    "data-old_color": "#000000",
    fill: "#5200F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 192c17.707 0 32-14.293 32-32s-14.293-32-32-32-32 14.293-32 32 14.293 32 32 32zM213.333 330.667c49.707 0 91.84-31.04 108.907-74.667H104.427c17.066 43.627 59.2 74.667 108.906 74.667z",
    "data-original": "#000000",
    className: "smile_svg__active-path",
    "data-old_color": "#000000",
    fill: "#5200F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.d6fe0833bce49c9716b173f39731a6cf.svg";
export { ForwardRef as ReactComponent };